"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
var _checkboxModule = _interopRequireDefault(require("./checkbox.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcCheckbox(props) {
  var disabled = props.disabled,
    checked = props.checked,
    name = props.name,
    value = props.value,
    displayKey = props.displayKey,
    options = props.options,
    defaultValue = props.defaultValue,
    onChange = props.onChange;
  var display = displayKey ? displayKey : "label";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _checkboxModule["default"].wrapper
  }, options ? /*#__PURE__*/_react["default"].createElement(_lib.Checkbox.Group, {
    options: options,
    defaultValue: defaultValue,
    onChange: onChange
  }) : /*#__PURE__*/_react["default"].createElement(_lib.Checkbox, {
    disabled: disabled,
    checked: checked,
    value: value,
    name: name,
    onChange: props.onChange
  }, props[display]));
}
var _default = ArcCheckbox;
exports["default"] = _default;